<template>
  <div  class="scroll-go-wrap">
    <div  @click="goTop" class="go-btn">
      <el-icon><Upload /></el-icon>
    </div>
    <div @click="goBottom" class="go-btn">
      <el-icon><Download /></el-icon>
    </div>
</div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useMainStore, } from "~/composables/store";
import { Upload, Download} from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { $t } from "~/utils/index.js";
import { get } from "lodash-es"; 
const store = useMainStore(); 
 
function goTop(){
  window.scrollTo({ top: 0, behavior: 'smooth' });

}
function goBottom(){
  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
}
</script>

<style scoped lang="less">
.scroll-go-wrap{
  width: 60px;
  height: 121px;
  background: #fff;

  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .05);
  border-radius: 4px;
  position: fixed;
  top: 76%;
  right: 0px;
  cursor: pointer;
  .go-btn{
    cursor: pointer;
    width: 60px;
    height: 60px;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #999;
    &:first-child{
      
      border-top-left-radius: 10px;
     
      
    }
    &:last-child{
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom:none;
    }
  }
}
 
</style>
